module.exports = __webpack_public_path__ + "img/ihe-logo.a6f0648b.png";